var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.89673H2.66665C1.93331 2.89673 1.33998 3.49673 1.33998 4.23006L1.33331 12.2301C1.33331 12.9634 1.93331 13.5634 2.66665 13.5634H13.3333C14.0666 13.5634 14.6666 12.9634 14.6666 12.2301V4.23006C14.6666 3.49673 14.0666 2.89673 13.3333 2.89673ZM13.0666 5.73006L8.35331 8.67673C8.13998 8.81006 7.85998 8.81006 7.64665 8.67673L2.93331 5.73006C2.86646 5.69254 2.80793 5.64184 2.76124 5.58103C2.71455 5.52023 2.68069 5.45058 2.6617 5.37631C2.64271 5.30204 2.63898 5.22469 2.65075 5.14893C2.66252 5.07318 2.68954 5.0006 2.73017 4.9356C2.7708 4.87059 2.8242 4.8145 2.88713 4.77073C2.95006 4.72695 3.02123 4.6964 3.09631 4.68093C3.17139 4.66545 3.24883 4.66537 3.32395 4.68069C3.39906 4.69601 3.47029 4.72642 3.53331 4.77006L7.99998 7.5634L12.4666 4.77006C12.5297 4.72642 12.6009 4.69601 12.676 4.68069C12.7511 4.66537 12.8286 4.66545 12.9036 4.68093C12.9787 4.6964 13.0499 4.72695 13.1128 4.77073C13.1758 4.8145 13.2292 4.87059 13.2698 4.9356C13.3104 5.0006 13.3374 5.07318 13.3492 5.14893C13.361 5.22469 13.3573 5.30204 13.3383 5.37631C13.3193 5.45058 13.2854 5.52023 13.2387 5.58103C13.192 5.64184 13.1335 5.69254 13.0666 5.73006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3d71143797b763d3c4be6f87dc71fb4f.svg";
export { ForwardRef as ReactComponent };